var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-wrapper"},[_c('button',{class:['menu-option', { selected: _vm.active }],style:({
      'background-color': _vm.bgColor
    }),attrs:{"tabindex":_vm.count === 0 ? -1 : 0}},[_c('transition',{attrs:{"name":"bounce-tab","mode":"out-in"}},[_c('p',{key:_vm.shouldAnimate,staticClass:"menu-option-text"},[_vm._t("default"),(_vm.showCount)?_c('span',{staticClass:"menu-option-count"},[_vm._v("("+_vm._s(_vm.count)+")")]):_vm._e()],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }